import style from './TestInstructions.scss';
import React from 'react';

const TestInstructions = () => {
  return (
    <div className={style['c-invite__test-instructions']}>
      <h3 className="font-weight-bold">Instructions</h3>
      <ul>
        <li>
          All coding problems are designed to read from stdin and your code is expected to write to
          stdout
        </li>
        <li>
          The system checks the correctness of your solution by running your code against different
          inputs and comparing the generated output with the expected output
        </li>
        <li>
          You will generally not be required to write code that reads from stdin. For most of the
          problems this code is already provided.
        </li>
        <li>
          In the code editor, you will see certain greyed out areas, these pieces of code are not
          editable, you are supposed to write your code in the editable area.
        </li>
        <li>
          When you hit the button to run code, all the code that is shown in the editor is run as a
          unit
        </li>
        <li>
          You can run your code with custom input to identify errors and fix failure. In this
          scenario, the system will not execute the testcases.
        </li>
        <li>
          To debug your code, please add print statements to print to console and run the code in
          the custom input mode.
        </li>
        <li>
          Do not close your browser window, while the test is in progress. If you close the window,
          you can resume the test by clicking the link in the invite email.
        </li>
      </ul>
    </div>
  );
};

export default TestInstructions;
